var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeartIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.33337 6.33332C1.33339 5.59145 1.55844 4.86704 1.9788 4.25576C2.39916 3.64448 2.99505 3.17509 3.68778 2.90959C4.38051 2.64408 5.13748 2.59495 5.85872 2.76868C6.57995 2.94242 7.23152 3.33084 7.72737 3.88265C7.7623 3.92 7.80452 3.94977 7.85142 3.97012C7.89833 3.99047 7.94891 4.00098 8.00004 4.00098C8.05117 4.00098 8.10175 3.99047 8.14866 3.97012C8.19556 3.94977 8.23778 3.92 8.27271 3.88265C8.767 3.32725 9.41872 2.93556 10.1411 2.75972C10.8635 2.58388 11.6224 2.63222 12.3166 2.89831C13.0109 3.1644 13.6076 3.63562 14.0274 4.24925C14.4473 4.86289 14.6702 5.58983 14.6667 6.33332C14.6667 7.85999 13.6667 8.99999 12.6667 9.99999L9.00537 13.542C8.88115 13.6847 8.72799 13.7993 8.55607 13.8782C8.38415 13.9571 8.1974 13.9986 8.00823 13.9997C7.81906 14.0009 7.63181 13.9619 7.4589 13.8851C7.28599 13.8084 7.13139 13.6957 7.00537 13.5547L3.33337 9.99999C2.33337 8.99999 1.33337 7.86665 1.33337 6.33332Z",
    stroke: "#0A0A0A",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartIcon);
export default __webpack_public_path__ + "static/media/HeartIcon.cc8ed920ded0a077f727a3ad62291950.svg";
export { ForwardRef as ReactComponent };